<template>
  <div id="about" class="py-5">
    <p class="text-h2 text-center my-10">Skills</p>
    <v-container>
      <v-row>
        <v-col
          cols="12"
          class="my-2"
          :key="skill.img"
          v-for="skill in skill_cards"
        >
          <v-card
            data-aos="fade-up"
            class="rounded-xl"
            :color="skill.background_color"
            elevation="5"
          >
            <v-container>
              <v-row class="align-center split-screen-container">
                <!-- Front image -->
                <v-col
                  align="center"
                  class="rounded-xl"
                  justify="center"
                  lg="3"
                  sm="4"
                  cols="12"
                >
                  <!-- Top Cards -->

                  <div class="pa-5">
                    <v-img
                      contain
                      min-height="80px"
                      height="10vh"
                      v-bind:src="require('../assets/' + skill.img)"
                      eager
                    >
                    </v-img>
                  </div>
                  <!-- End top cards -->
                </v-col>

                <v-col
                  v-if="false"
                  class="white--black"
                  lg="9"
                  sm="8"
                  cols="12"
                >
                  <div class="text-center">
                    <h1 style="font-size: 45px">
                      {{ skill.title }}
                    </h1>
                  </div>
                </v-col>
                <!-- Details content -->
                <v-col
                  v-if="true"
                  class="white--text rounded-xl split-screen-right card-background"
                  lg="9"
                  sm="8"
                  cols="12"
                >
                  <div>
                    <v-card-title primary-title>
                      <transition name="slide-fade" mode="out-in">
                        <div :key="skill.title">
                          {{ skill.title }}
                        </div>
                      </transition>
                    </v-card-title>

                    <hr />
                    <v-card-text>
                      <transition name="slide-fade" mode="out-in">
                        <div :key="skill.title">
                          <ul
                            class="text-left"
                            v-for="element in skill.innerTextPoints"
                            :key="element"
                          >
                            <li>{{ element }}</li>
                          </ul>
                        </div>
                      </transition>
                    </v-card-text>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="main-bd" fluid>
      <v-row class="mt-10 justify-center align-center">
        <v-col cols="12" md="3" class="d-flex justify-center">
          <div class="profile-square mt-10 primary-light d-flex justify-center">
            <v-img contain class="profile-icon" src="../assets/profile2.png" />
          </div>
        </v-col>
        <v-col
          data-aos="fade-left"
          cols="12"
          md="8"
          lg="9"
          offset-lg="0"
          offset-md="1"
        >
          <p class="text-h5 white--text">
            Full-stack web developer with a passion for creating dynamic,
            user-friendly applications. My expertise extends to cloud
            infrastructure and mobile development, allowing me to architect and
            deliver seamless solutions across platforms.
          </p>
          <v-btn @click="openCoverLetter()" large class="mt-2"
            >My Cover Letter</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addWrapping: false,
      detailGridClosing: false,
      detailGridOpening: false,
      skill_cards: [
        {
          title: "JavaScript",
          background_color: "#F7DF1E",
          img: "jslogo.svg",
          innerTextPoints: [
            "Multi-year experience using NodeJS and web-frameworks",
            "2 years professional experience with Angular, RxJS and NgRX",
            "Maintaining native mobile and web applications built with React and React Native",
            "Multiple projects built on Vue.js",
            "Integration with websockets, animations and serverless-solutions",
          ],
          detailsImg: require(`@/assets/VueReactAngularLogo.png`),
          isActive: null,
        },
        {
          title: "C#",
          background_color: "#4E3079",
          img: "csharplogo.svg",
          innerTextPoints: [
            "Advanced experience with OOP design patterns and best practices",
            "Maintaining production-ready backend solutions using Docker and Kubernetes",
            "Azure services integration",
            "Full duplex communication with SignalR",
          ],
          detailsImg: require(`@/assets/.NET_Logo.png`),
          isActive: null,
        },
        {
          title: "Kotlin",
          background_color: "#334776",
          img: "kotlinlogo.svg",
          innerTextPoints: [
            "Creator and maintainer of multiple mobile applications",
            "Integration with serverless-solutions",
            "Deploying applications to Google PlayStore",
            "Following Google Jetpack best practices",
          ],
          detailsImg: require(`@/assets/AndroidAppleLogo.png`),

          isActive: null,
        },
        // {
        //   title: "Laravel",
        //   background_color: "#B90000",
        //   img: "laravellogo.svg",
        //   innerTextPoints: [
        //     "Full-stack web solutions",
        //     "Integration with Vue.js",
        //   ],
        //   detailsImg: require(`@/assets/LaravelLogo.png`),

        //   isActive: null,
        // },
        {
          title: "Amazon Web Services",
          background_color: "#fff",
          img: "awslogo.svg",
          innerTextPoints: [
            "Multi-year professional experience managing cloud infrastructure",
            "Serverless integration with frontend web solutions",
            "Handling security and per user access-control",
            "Multi-service proficiency: S3, Lambda, DynamoDB, IAM, Amplify, Cognito etc.",
          ],
          detailsImg: require(`@/assets/awsfulllogo.jpg`),

          isActive: null,
        },
      ],
    };
  },

  methods: {
    openCoverLetter() {
      window.open("/Aleksandar_Todorov_CV.pdf", "_blank");
    },
  },

  computed: {},
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.card-background {
  background-color: #2c2c2c;
}

.split-screen-container {
  overflow: hidden;
}

.text-no-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expansion-panel {
  background-color: rgb(44, 44, 44);
}
.card-actions {
  background-color: rgba(0, 0, 0, 0.3);
  transition: 200ms;
}

.card-actions:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

hr {
  height: 2px;
  border-width: 0;
  color: gray;
  background-color: gray;
}

.about-squares {
  background-color: rgb(44, 44, 44);
  height: 150px;
  width: 150px;
  border-radius: 30px;
  margin-bottom: 8em;
}
.main-bd {
  background-color: rgb(44, 44, 44);
}
.profile-square {
  height: 250px;
  width: 250px;
  border-radius: 10px;
  margin-bottom: 8em;
  transform: rotate(45deg);
  background-color: rgb(255, 255, 255, 0.2);
}

.profile-icon {
  margin: auto;
  width: 50%;
  margin: 10px;
  transform: rotate(-45deg);
}

.inner-icon {
  height: 130px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .inner-icon {
    height: 90px;
  }

  .profile-square {
    width: 150px;
    height: 150px;
  }
}
</style>